import { useEffect } from 'react';

import { useFormErrorContext } from '@/context/FormErrorContext';

export const FormikScrollToError = () => {
    const [errors] = useFormErrorContext();

    useEffect(() => {
        if (errors && Object.keys(errors).length > 0) {
            const errorKeyValue = Object.entries(errors).find(
                ([, value]) => !!value
            );

            if (errorKeyValue) {
                const [firstErrorKey] = errorKeyValue;
                const firstErrorElement = document.querySelector(
                    `[name="${firstErrorKey}"]`
                );
                if (firstErrorElement) {
                    firstErrorElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                    });
                }
            }
        }
    }, [errors]);

    return null;
};
